/* eslint-disable react/require-default-props */
import React from 'react';
import FilterPanel from '@components/FilterPanel';
import SearchPanel from '@components/SearchPanel';
import { translate } from '@utils/i18n';
import useComponentTypeFilters from '../hooks/useComponentTypeFilters';
import './ComponentTypesFilterPanelStyles.scss';
const namespace = 'features.settings.component_types.filter_panel';
export default function ComponentTypesFilterPanel({ filters, onFiltersChange, allowedAttachableTypes, onResetCache }) {
    const handleSearchChange = (value) => {
        onFiltersChange(Object.assign(Object.assign({}, filters), { search: value }));
    };
    const handleResetFilters = () => {
        onFiltersChange({
            search: '',
            allowedAttachableTypes: []
        });
    };
    const handleResetCache = () => {
        if (onResetCache) {
            onResetCache();
        }
    };
    // Get filter list using the hook
    const filtersList = useComponentTypeFilters({
        filters,
        onFiltersChange,
        allowedAttachableTypes
    });
    return (React.createElement("div", { className: "component-types-filter-panel" },
        React.createElement("div", { className: "filters__group--search" },
            React.createElement(SearchPanel, { placeholder: translate('search_placeholder', { namespace }), onChange: handleSearchChange })),
        React.createElement(FilterPanel, { onResetFilters: handleResetFilters, onResetCache: handleResetCache, filters: filtersList })));
}
